import { createFileRoute } from "@tanstack/react-router";
import { QueueGroupForm } from "../-components/queue-group-form";
import { useQuery } from "@tanstack/react-query";
import { queueGroupQueryOptions } from "@/server/queues";
import { QueueGroupReadable } from "@/lib/mma/types.gen";
import { useEffect } from "react";

export const Route = createFileRoute("/_dashboard/queue-groups/$queueGroupId/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { queueGroupId } = Route.useParams();
  const queueGroupQuery = useQuery(queueGroupQueryOptions(Number(queueGroupId)));
  const queueGroup = queueGroupQuery.data as QueueGroupReadable;

  useEffect(() => {
    if (!queueGroupId) return;
    void queueGroupQuery.refetch();
  }, [queueGroupId, queueGroupQuery.refetch]);

  return <QueueGroupForm queueGroup={queueGroup} isEdit={true} />;
}
